<template>
  <div class="relative inline-block">
    <!-- Info Icon (You can customize the icon, here we use an SVG) -->
     <div class="flex justify-center items-center w-full h-full">
        <svg
        class="w-5 h-5  text-gray-400 cursor-pointer"
        @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false"
        @click="toggleTooltip"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
        >
        <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 00-2 0v5a1 1 0 002 0V5zm0 8a1 1 0 00-2 0v2a1 1 0 002 0v-2z"
            clip-rule="evenodd"
        />
        </svg>
    </div>
    <!-- Tooltip (appears on hover or click) -->
    <div
      v-if="showTooltip"
      class="absolute z-10 w-64 p-2 mt-2 text-sm text-white bg-black rounded-md shadow-lg opacity-100"
      :class="positionClass"
      style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;"
    >
      <p style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">{{ tooltipText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tooltipText: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'top' // 'top', 'bottom', 'left', 'right'
    }
  },
  data() {
    return {
      showTooltip: false
    };
  },
  computed: {
    // Dynamically set the tooltip's position based on the `position` prop
    positionClass() {
      switch (this.position) {
        case 'top':
          return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2';
        case 'bottom':
          return 'top-full left-1/2 transform -translate-x-1/2 mt-2';
        case 'left':
          return 'right-full top-1/2 transform -translate-y-1/2 mr-2';
        case 'right':
          return 'left-full top-1/2 transform -translate-y-1/2 ml-2';
        default:
          return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2';
      }
    }
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    }
  }
};
</script>

<style scoped>
/* Optional styles for tooltip */
</style>
